// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ElectionPost from "./election-post.js"
import SchoolClass from "./school-class.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": true,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_method": {
      "column": {
        "default": "contact",
        "name": "election_method",
        "null": false,
        "type": "string"
      },
      "name": "election_method",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "translated_election_method": {
      "column": null,
      "name": "translated_election_method",
      "selected_by_default": null,
      "translated": null
    },
    "visible_in_overview": {
      "column": {
        "default": false,
        "name": "visible_in_overview",
        "null": false,
        "type": "boolean"
      },
      "name": "visible_in_overview",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Election",
  "collectionKey": "elections",
  "collectionName": "elections",
  "i18nKey": "election",
  "camelizedLower": "election",
  "name": "Election",
  "nameDasherized": "election",
  "pluralName": "elections",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_id",
      "name": "election_posts",
      "macro": "has_many",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_posts"
    },
    {
      "className": "SchoolElection",
      "collectionName": "school_elections",
      "foreignKey": "school_election_id",
      "name": "school_election",
      "macro": "belongs_to",
      "resource_name": "SchoolElection",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_method",
      "column": {
        "default": "contact",
        "name": "election_method",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "school_election_id",
      "column": {
        "default": null,
        "name": "school_election_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "visible_in_overview",
      "column": {
        "default": false,
        "name": "visible_in_overview",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_id",
      "name": "election_posts",
      "macro": "has_many",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_posts"
    }
  ],
  "paramKey": "election",
  "primaryKey": "id"
}

/** Frontend model for Election. */
export default class Election extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionMethod() {
    return this.readAttributeUnderscore("election_method")
  }

  /** @returns {boolean} */
  hasElectionMethod() {
    const value = this.electionMethod()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElectionMethod() {
    return this.readAttributeUnderscore("translated_election_method")
  }

  /** @returns {boolean} */
  hasTranslatedElectionMethod() {
    const value = this.translatedElectionMethod()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visibleInOverview() {
    return this.readAttributeUnderscore("visible_in_overview")
  }

  /** @returns {boolean} */
  hasVisibleInOverview() {
    const value = this.visibleInOverview()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./election-post.js").default>} */
  electionPosts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["election_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "election_posts",
        model: this,
        modelClass: ElectionPost
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election-post.js").default>>} */
  loadElectionPosts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["election_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "election_posts",
        model: this,
        modelClass: ElectionPost
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election-post.js").default>>} */
  ensureElectionPostsLoaded() {
    return this.ensureAssociationLoaded("election_posts")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "Election",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "Election",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }
}
